import { useMutation } from "react-query";

import {
  DataAnalyzerRequest,
  WellPerformanceDataAnalyzerResult,
  postWellPerformanceDataAnalyzer
} from "api/appTools";

export default function useWellPerformanceDataAnalyzer(
  handlePostData: (postData: WellPerformanceDataAnalyzerResult) => void,
  handleError: (err) => void = null
) {
  const { isLoading, isError, error, mutate, data } = useMutation(
    "postWellPerformanceDataAnalyzer",
    async (request: DataAnalyzerRequest) => {
      const result = await postWellPerformanceDataAnalyzer(request);
      return result;
    },
    {
      onSuccess: (postData) => {
        handlePostData(postData);
      },
      onError: (err) => {
        if (handleError) {
          handleError(err);
        } else {
          // eslint-disable-next-line no-console
          console.error(err);
        }
      }
    }
  );

  return { isLoading, isError, error, mutate, data };
}
